/* =============================================
   SEA PLAY HOMES – THEME JAVASCRIPT
   ============================================= */

(function() {
  'use strict';

  // ---- MOBILE MENU ----
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.getElementById('mobile-close');

  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      mobileMenuBtn.setAttribute('aria-expanded', 'true');
    });
    mobileClose && mobileClose.addEventListener('click', closeMenu);
    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
      mobileMenuBtn.setAttribute('aria-expanded', 'false');
    }
  }

  // ---- FAQ ACCORDION ----
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ---- PRODUCT GALLERY ----
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      const mainImg = gallery.querySelector('.product-main-image img');
      const src = thumb.querySelector('img').src;
      if (mainImg) {
        mainImg.src = src;
        gallery.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      }
    });
  });



  // ---- CART CUSTOM FIELDS VALIDATION ----
  const checkoutBtn = document.getElementById('checkout-btn');
  const deliveryDate = document.getElementById('delivery-date');
  const pickupDate = document.getElementById('pickup-date');

  if (checkoutBtn) {
    // Set minimum date to today
    const today = new Date().toISOString().split('T')[0];
    if (deliveryDate) deliveryDate.min = today;
    if (pickupDate) pickupDate.min = today;

    // Validate pickup > delivery
    if (deliveryDate && pickupDate) {
      deliveryDate.addEventListener('change', () => {
        pickupDate.min = deliveryDate.value || today;
        if (pickupDate.value && pickupDate.value < deliveryDate.value) {
          pickupDate.value = '';
        }
      });
    }

    checkoutBtn.addEventListener('click', (e) => {
      let valid = true;

      // Validate delivery date
      if (deliveryDate && !deliveryDate.value) {
        e.preventDefault();
        deliveryDate.classList.add('error');
        const err = document.getElementById('delivery-date-error');
        if (err) err.classList.add('visible');
        valid = false;
      } else if (deliveryDate) {
        deliveryDate.classList.remove('error');
        const err = document.getElementById('delivery-date-error');
        if (err) err.classList.remove('visible');
      }

      // Validate pickup date
      if (pickupDate && !pickupDate.value) {
        e.preventDefault();
        pickupDate.classList.add('error');
        const err = document.getElementById('pickup-date-error');
        if (err) err.classList.add('visible');
        valid = false;
      } else if (pickupDate) {
        pickupDate.classList.remove('error');
        const err = document.getElementById('pickup-date-error');
        if (err) err.classList.remove('visible');
      }

      if (!valid) {
        // Scroll to fields
        const firstError = document.querySelector('.form-input.error');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // Attach cart attributes via AJAX before redirect
      if (valid) {
        e.preventDefault();
        saveCartAttributesAndCheckout();
      }
    });
  }

  function saveCartAttributesAndCheckout() {
    const deliveryVal = document.getElementById('linen-delivery-date')?.value || '';
    const pickupVal = document.getElementById('pickup-date')?.value || '';
    const noteVal = document.getElementById('order-note')?.value || '';
    const addressVal = document.getElementById('delivery-address')?.value || '';

    // Format dates nicely
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const d = new Date(dateStr + 'T00:00:00');
      return d.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    };

    const attributes = {
      'Linen Delivery Date': formatDate(deliveryVal),
      'Pickup Date': formatDate(pickupVal),
    };
    if (addressVal) attributes['Delivery Address'] = addressVal;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: attributes,
        note: noteVal
      })
    })
    .then(res => res.json())
    .then(() => {
      window.location.href = '/checkout';
    })
    .catch(() => {
      window.location.href = '/checkout';
    });
  }

  // ---- CONTACT FORM ----
  const contactForm = document.getElementById('contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = contactForm.querySelector('[type="submit"]');
      const successMsg = document.getElementById('contact-success');

      btn.textContent = 'Sending...';
      btn.disabled = true;

      // Shopify contact form submission
      const formData = new FormData(contactForm);
      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(res => {
        if (successMsg) {
          successMsg.style.display = 'block';
          contactForm.reset();
        }
        btn.textContent = 'Message Sent!';
      })
      .catch(() => {
        btn.textContent = 'Send Message';
        btn.disabled = false;
        alert('There was an error. Please email us directly at linens@seaplayhomes.com');
      });
    });
  }

  // ---- SMOOTH SCROLL ----
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- STICKY HEADER SHADOW ----
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    window.addEventListener('scroll', () => {
      siteHeader.classList.toggle('scrolled', window.scrollY > 10);
    });
  }

  // ---- ANIMATE ON SCROLL ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.step, .product-card, .testimonial-card, .why-card, .service-area-card, .category-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

  document.addEventListener('animateIn', (e) => {
    if (e.target.classList.contains('animate-in')) {
      e.target.style.opacity = '1';
      e.target.style.transform = 'translateY(0)';
    }
  });

  // Trigger animation
  document.querySelectorAll('.animate-in').forEach(el => {
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
  });

  // Watch for class additions
  const animObserver = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        const el = m.target;
        if (el.classList.contains('animate-in')) {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }
      }
    });
  });

  document.querySelectorAll('.step, .product-card, .testimonial-card, .why-card, .service-area-card, .category-card').forEach(el => {
    animObserver.observe(el, { attributes: true });
  });

  // ---- DESKTOP NAV DROPDOWN — JS-controlled with 120ms close delay ----
  // Replaces the CSS-only :hover so the menu stays open as the mouse
  // travels from the trigger button into the dropdown panel.
  document.querySelectorAll('.nav-item').forEach(function(item) {
    if (!item.querySelector('.nav-dropdown')) return;
    var timer;
    function open()  { clearTimeout(timer); item.classList.add('nav-open'); }
    function close() { timer = setTimeout(function() { item.classList.remove('nav-open'); }, 120); }
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.querySelector('.nav-dropdown').addEventListener('mouseenter', open);
    item.querySelector('.nav-dropdown').addEventListener('mouseleave', close);
  });
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.nav-item')) {
      document.querySelectorAll('.nav-item.nav-open').forEach(function(el) { el.classList.remove('nav-open'); });
    }
  });

  // ---- DATE PICKER BAR — injected after the header on every page ----
  (function() {
    var SS_D = 'sph_delivery_date';
    var SS_P = 'sph_pickup_date';

    function tomorrowStr() {
      var d = new Date(); d.setDate(d.getDate() + 1);
      return d.toISOString().split('T')[0];
    }
    function fmtShort(s) {
      if (!s) return '';
      var p = s.split('-');
      return new Date(+p[0], +p[1]-1, +p[2]).toLocaleDateString('en-US', {month:'short', day:'numeric', year:'numeric'});
    }
    function fmtFull(s) {
      if (!s) return '';
      var p = s.split('-');
      return new Date(+p[0], +p[1]-1, +p[2]).toLocaleDateString('en-US', {weekday:'long', year:'numeric', month:'long', day:'numeric'});
    }
    function getSaved() {
      try { return { d: sessionStorage.getItem(SS_D)||'', p: sessionStorage.getItem(SS_P)||'' }; }
      catch(e) { return { d:'', p:'' }; }
    }
    function setSaved(d, p) {
      try { sessionStorage.setItem(SS_D, d); sessionStorage.setItem(SS_P, p); } catch(e) {}
    }
    function syncCart(d, p) {
      var attrs = {};
      // Save raw yyyy-mm-dd so the cart page <input type="date"> can read it back.
      // The cart's checkout JS re-formats to the readable string before sending to Shopify.
      if (d) attrs['Linen Delivery Date'] = d;
      if (p) attrs['Pickup Date']          = p;
      if (!Object.keys(attrs).length) return;
      fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes:attrs})}).catch(function(){});
    }

    var siteHeader = document.querySelector('.site-header');
    if (!siteHeader) return;

    var bar = document.createElement('div');
    bar.id        = 'sph-date-bar';
    bar.className = 'sph-date-bar';
    bar.innerHTML =
      '<div class="sph-db-inner">' +
        '<p class="sph-db-label">Select your rental dates</p>' +
        '<div class="sph-db-fields">' +
          '<div class="sph-db-field">' +
            '<label class="sph-db-flabel" for="sph-d-date">Delivery Date</label>' +
            '<input type="date" id="sph-d-date" class="sph-db-input" autocomplete="off">' +
          '</div>' +
          '<span class="sph-db-arrow">&#8594;</span>' +
          '<div class="sph-db-field">' +
            '<label class="sph-db-flabel" for="sph-p-date">Pickup Date</label>' +
            '<input type="date" id="sph-p-date" class="sph-db-input" autocomplete="off">' +
          '</div>' +
          '<button type="button" id="sph-db-apply" class="sph-db-btn">Apply Dates</button>' +
        '</div>' +
        '<div class="sph-db-confirm" id="sph-db-confirm" hidden>' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2DC4B5" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>' +
          '<span id="sph-db-ctxt"></span>' +
          '<button type="button" class="sph-db-edit" id="sph-db-edit">Change dates</button>' +
        '</div>' +
        '<p class="sph-db-error" id="sph-db-err" hidden></p>' +
      '</div>';

    siteHeader.insertAdjacentElement('afterend', bar);

    var dIn   = document.getElementById('sph-d-date');
    var pIn   = document.getElementById('sph-p-date');
    var apBtn = document.getElementById('sph-db-apply');
    var cfEl  = document.getElementById('sph-db-confirm');
    var cfTxt = document.getElementById('sph-db-ctxt');
    var edBtn = document.getElementById('sph-db-edit');
    var errEl = document.getElementById('sph-db-err');
    var flds  = bar.querySelector('.sph-db-fields');

    var minD = tomorrowStr();
    dIn.min = minD; pIn.min = minD;

    function showConf(d, p) {
      flds.style.display = 'none';
      cfTxt.textContent  = 'Delivery: ' + fmtShort(d) + '  \u2192  Pickup: ' + fmtShort(p);
      cfEl.hidden = false;
      if (errEl) errEl.hidden = true;
    }
    function showFlds() { flds.style.display = ''; cfEl.hidden = true; }
    function showErr(m) { if (errEl) { errEl.textContent = m; errEl.hidden = false; } }

    function apply() {
      var d = dIn.value, p = pIn.value;
      if (errEl) errEl.hidden = true;
      if (!d) { showErr('Please select a delivery date.'); dIn.focus(); return; }
      if (!p) { showErr('Please select a pickup date.');   pIn.focus(); return; }
      if (p < d) { showErr('Pickup must be on or after delivery date.'); pIn.focus(); return; }
      dIn.classList.add('sph-db-set'); pIn.classList.add('sph-db-set');
      setSaved(d, p); syncCart(d, p); showConf(d, p);
      // Pre-fill cart page inputs if present
      // Cart uses id="linen-delivery-date" for delivery and id="pickup-date" for pickup
      var cd = document.getElementById('linen-delivery-date');
      var cp = document.getElementById('pickup-date');
      if (cd && !cd.value) { cd.value = d; cd.dispatchEvent(new Event('change')); }
      if (cp && !cp.value)   cp.value = p;
    }

    dIn.addEventListener('change', function() {
      if (this.value) { pIn.min = this.value; if (pIn.value && pIn.value < this.value) pIn.value = ''; }
    });
    apBtn.addEventListener('click', apply);
    [dIn, pIn].forEach(function(el) { el.addEventListener('keydown', function(e) { if (e.key === 'Enter') apply(); }); });
    edBtn.addEventListener('click', function() { showFlds(); dIn.focus(); });

    // Restore from sessionStorage on page load
    var sv = getSaved();
    if (sv.d && sv.p) {
      dIn.value = sv.d; pIn.value = sv.p;
      dIn.classList.add('sph-db-set'); pIn.classList.add('sph-db-set');
      showConf(sv.d, sv.p);
      syncCart(sv.d, sv.p);
    }
  }());

})();
